import React from "react";
import mysvg from '../../../../../src/img/wave.svg'
const Stat = () => {
  return (
    <section className="text-gray-600 body-font " style={{ backgroundImage: `url(${mysvg})`, backgroundRepeat:"no-repeat"}}>
         <h2 className="text-4xl text-center font-extrabold tracking-tight text-black">Over the last Year</h2>
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap -m-4 text-center">
          <div className="p-4 sm:w-1/4 w-1/2">
            <h2 className="title-font font-medium sm:text-4xl text-3xl text-black">
              2.7K
            </h2>
            <p className="leading-relaxed">Users</p>
          </div>
          <div className="p-4 sm:w-1/4 w-1/2">
            <h2 className="title-font font-medium sm:text-4xl text-3xl text-black">
              180K
            </h2>
            <p className="leading-relaxed">Restock</p>
          </div>
          <div className="p-4 sm:w-1/4 w-1/2">
            <h2 className="title-font font-medium sm:text-4xl text-3xl text-black">
              3500K
            </h2>
            <p className="leading-relaxed">Deliverd</p>
          </div>
          <div className="p-4 sm:w-1/4 w-1/2">
            <h2 className="title-font font-medium sm:text-4xl text-3xl text-black">
              458
            </h2>
            <p className="leading-relaxed">Products</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stat;
